import { TestTemplateResultsUom } from "./types"

import { TestTemplateComparison } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

export const TEST_TEMPLATES_COMPARISON_TO_LABEL: ReadonlyMap<string, string> = new Map([
  [TestTemplateComparison.EqualTo, "Equal to"],
  [TestTemplateComparison.Maximum, "Maximum"],
  [TestTemplateComparison.Minimum, "Minimum"],
  [TestTemplateComparison.NoResult, "No Result"],
  [TestTemplateComparison.PassFail, "Pass/Fail"],
  [TestTemplateComparison.Range, "Range"],
  [TestTemplateComparison.ReportOnly, "Report Only"],
  [TestTemplateComparison.YesNo, "Yes/No"],
])

export const TEST_TEMPLATE_RESULT_UOM_OPTIONS: readonly Option<string>[] = [
  { value: TestTemplateResultsUom.PercentMPerM, label: TestTemplateResultsUom.PercentMPerM },
  { value: TestTemplateResultsUom.PercentWt, label: TestTemplateResultsUom.PercentWt },
  { value: TestTemplateResultsUom.HundredMlPerGm, label: TestTemplateResultsUom.HundredMlPerGm },
  { value: TestTemplateResultsUom.APHA, label: TestTemplateResultsUom.APHA },
  { value: TestTemplateResultsUom.C, label: TestTemplateResultsUom.C },
  { value: TestTemplateResultsUom.Cgs, label: TestTemplateResultsUom.Cgs },
  { value: TestTemplateResultsUom.F, label: TestTemplateResultsUom.F },
  { value: TestTemplateResultsUom.Gardner, label: TestTemplateResultsUom.Gardner },
  { value: TestTemplateResultsUom.KU, label: TestTemplateResultsUom.KU },
  { value: TestTemplateResultsUom.Lbs, label: TestTemplateResultsUom.Lbs },
  { value: TestTemplateResultsUom.LWUV, label: TestTemplateResultsUom.LWUV },
  { value: TestTemplateResultsUom.PaS, label: TestTemplateResultsUom.PaS },
  { value: TestTemplateResultsUom.PtCo, label: TestTemplateResultsUom.PtCo },
  { value: TestTemplateResultsUom.ShoreA, label: TestTemplateResultsUom.ShoreA },
  { value: TestTemplateResultsUom.ShoreD, label: TestTemplateResultsUom.ShoreD },
  { value: TestTemplateResultsUom.Cp, label: TestTemplateResultsUom.Cp },
  { value: TestTemplateResultsUom.Cst, label: TestTemplateResultsUom.Cst },
  { value: TestTemplateResultsUom.Cc, label: TestTemplateResultsUom.Cc },
  { value: TestTemplateResultsUom.CcPer100g, label: TestTemplateResultsUom.CcPer100g },
  { value: TestTemplateResultsUom.CcPer50g, label: TestTemplateResultsUom.CcPer50g },
  { value: TestTemplateResultsUom.CcPerG, label: TestTemplateResultsUom.CcPerG },
  { value: TestTemplateResultsUom.CgIPerG, label: TestTemplateResultsUom.CgIPerG },
  { value: TestTemplateResultsUom.CgPerCm3, label: TestTemplateResultsUom.CgPerCm3 },
  { value: TestTemplateResultsUom.CgIPerG_Alt, label: TestTemplateResultsUom.CgIPerG_Alt },
  { value: TestTemplateResultsUom.Cm, label: TestTemplateResultsUom.Cm },
  { value: TestTemplateResultsUom.Cm2PerG, label: TestTemplateResultsUom.Cm2PerG },
  { value: TestTemplateResultsUom.Cm3PerG, label: TestTemplateResultsUom.Cm3PerG },
  { value: TestTemplateResultsUom.DlPerG, label: TestTemplateResultsUom.DlPerG },
  { value: TestTemplateResultsUom.DnM, label: TestTemplateResultsUom.DnM },
  { value: TestTemplateResultsUom.DegreesC, label: TestTemplateResultsUom.DegreesC },
  { value: TestTemplateResultsUom.DegreesF, label: TestTemplateResultsUom.DegreesF },
  { value: TestTemplateResultsUom.Dmm, label: TestTemplateResultsUom.Dmm },
  { value: TestTemplateResultsUom.Ea, label: TestTemplateResultsUom.Ea },
  { value: TestTemplateResultsUom.G, label: TestTemplateResultsUom.G },
  { value: TestTemplateResultsUom.GPer10Min, label: TestTemplateResultsUom.GPer10Min },
  { value: TestTemplateResultsUom.GPer100g, label: TestTemplateResultsUom.GPer100g },
  { value: TestTemplateResultsUom.GPer100Ml, label: TestTemplateResultsUom.GPer100Ml },
  { value: TestTemplateResultsUom.GPerL, label: TestTemplateResultsUom.GPerL },
  { value: TestTemplateResultsUom.GPerCm3, label: TestTemplateResultsUom.GPerCm3 },
  { value: TestTemplateResultsUom.GPerEq, label: TestTemplateResultsUom.GPerEq },
  { value: TestTemplateResultsUom.GPerG, label: TestTemplateResultsUom.GPerG },
  { value: TestTemplateResultsUom.GPerKg, label: TestTemplateResultsUom.GPerKg },
  { value: TestTemplateResultsUom.GPerMl, label: TestTemplateResultsUom.GPerMl },
  { value: TestTemplateResultsUom.GPerMol, label: TestTemplateResultsUom.GPerMol },
  { value: TestTemplateResultsUom.GPerS, label: TestTemplateResultsUom.GPerS },
  { value: TestTemplateResultsUom.Gl2Per100g, label: TestTemplateResultsUom.Gl2Per100g },
  { value: TestTemplateResultsUom.GmPer10Min, label: TestTemplateResultsUom.GmPer10Min },
  { value: TestTemplateResultsUom.GmPerCc, label: TestTemplateResultsUom.GmPerCc },
  { value: TestTemplateResultsUom.InLb, label: TestTemplateResultsUom.InLb },
  { value: TestTemplateResultsUom.Kg, label: TestTemplateResultsUom.Kg },
  { value: TestTemplateResultsUom.KgPerL, label: TestTemplateResultsUom.KgPerL },
  { value: TestTemplateResultsUom.KgPerCm2, label: TestTemplateResultsUom.KgPerCm2 },
  { value: TestTemplateResultsUom.KgPerM3, label: TestTemplateResultsUom.KgPerM3 },
  { value: TestTemplateResultsUom.LbIn, label: TestTemplateResultsUom.LbIn },
  { value: TestTemplateResultsUom.LbPerFt3, label: TestTemplateResultsUom.LbPerFt3 },
  { value: TestTemplateResultsUom.LbfIn, label: TestTemplateResultsUom.LbfIn },
  { value: TestTemplateResultsUom.LbsPerGal, label: TestTemplateResultsUom.LbsPerGal },
  { value: TestTemplateResultsUom.M2PerG, label: TestTemplateResultsUom.M2PerG },
  { value: TestTemplateResultsUom.Ml, label: TestTemplateResultsUom.Ml },
  { value: TestTemplateResultsUom.MlPer100g, label: TestTemplateResultsUom.MlPer100g },
  { value: TestTemplateResultsUom.MlPer50g, label: TestTemplateResultsUom.MlPer50g },
  { value: TestTemplateResultsUom.MlPerG, label: TestTemplateResultsUom.MlPerG },
  { value: TestTemplateResultsUom.MPaS, label: TestTemplateResultsUom.MPaS },
  { value: TestTemplateResultsUom.McdPerM2, label: TestTemplateResultsUom.McdPerM2 },
  { value: TestTemplateResultsUom.MePerG, label: TestTemplateResultsUom.MePerG },
  { value: TestTemplateResultsUom.MeqPer100g, label: TestTemplateResultsUom.MeqPer100g },
  { value: TestTemplateResultsUom.Mesh, label: TestTemplateResultsUom.Mesh },
  { value: TestTemplateResultsUom.MgKOHPerG, label: TestTemplateResultsUom.MgKOHPerG },
  { value: TestTemplateResultsUom.MgPerCc, label: TestTemplateResultsUom.MgPerCc },
  { value: TestTemplateResultsUom.MgPerG, label: TestTemplateResultsUom.MgPerG },
  { value: TestTemplateResultsUom.MgPerK, label: TestTemplateResultsUom.MgPerK },
  { value: TestTemplateResultsUom.MgPerKg, label: TestTemplateResultsUom.MgPerKg },
  { value: TestTemplateResultsUom.MgPerM3, label: TestTemplateResultsUom.MgPerM3 },
  { value: TestTemplateResultsUom.Min, label: TestTemplateResultsUom.Min },
  { value: TestTemplateResultsUom.MlsNPer20, label: TestTemplateResultsUom.MlsNPer20 },
  { value: TestTemplateResultsUom.Mm, label: TestTemplateResultsUom.Mm },
  { value: TestTemplateResultsUom.Mm2PerSec, label: TestTemplateResultsUom.Mm2PerSec },
  { value: TestTemplateResultsUom.MmolPerG, label: TestTemplateResultsUom.MmolPerG },
  { value: TestTemplateResultsUom.MmolPerKg, label: TestTemplateResultsUom.MmolPerKg },
  { value: TestTemplateResultsUom.Mol, label: TestTemplateResultsUom.Mol },
  { value: TestTemplateResultsUom.MolPerKg, label: TestTemplateResultsUom.MolPerKg },
  { value: TestTemplateResultsUom.Nm, label: TestTemplateResultsUom.Nm },
  { value: TestTemplateResultsUom.Ohm, label: TestTemplateResultsUom.Ohm },
  { value: TestTemplateResultsUom.OhmPerSq, label: TestTemplateResultsUom.OhmPerSq },
  { value: TestTemplateResultsUom.PelletsPerG, label: TestTemplateResultsUom.PelletsPerG },
  { value: TestTemplateResultsUom.Percent, label: TestTemplateResultsUom.Percent },
  { value: TestTemplateResultsUom.Poise, label: TestTemplateResultsUom.Poise },
  { value: TestTemplateResultsUom.Pounds, label: TestTemplateResultsUom.Pounds },
  { value: TestTemplateResultsUom.Ppm, label: TestTemplateResultsUom.Ppm },
  { value: TestTemplateResultsUom.Psi, label: TestTemplateResultsUom.Psi },
  { value: TestTemplateResultsUom.Rpm, label: TestTemplateResultsUom.Rpm },
  { value: TestTemplateResultsUom.Seconds, label: TestTemplateResultsUom.Seconds },
  { value: TestTemplateResultsUom.Stokes, label: TestTemplateResultsUom.Stokes },
  { value: TestTemplateResultsUom.USPerCm, label: TestTemplateResultsUom.USPerCm },
  { value: TestTemplateResultsUom.Micrometer, label: "μm" },
  { value: TestTemplateResultsUom.Unit, label: TestTemplateResultsUom.Unit },
  { value: TestTemplateResultsUom.Units, label: TestTemplateResultsUom.Units },
  { value: TestTemplateResultsUom.WtPercent, label: TestTemplateResultsUom.WtPercent },
].sort((a, b) => a.label.localeCompare(b.label))
